export class PaymentFailController {
  constructor($scope, $route, PaymentService) {
    this.scope = $scope;
    this.route = $route;
    this.PaymentService = PaymentService;

    this.init();
  }

  init() {
    if(this.route.current.params.transaction) {
      this.scope.transaction = this.route.current.params.transaction;
    }

    //send reject message
    this.PaymentService.sendRejectMessage()
      .catch((response) => { let err = response.data;
        console.error(err);
      })
  }
}
